"use strict";
// Copyright © Veeam Software Group GmbH
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordField = void 0;
const react_1 = __importDefault(require("react"));
const components_1 = require("@veeam/components");
const layout_1 = require("../layout");
require("../types");
function PasswordField(_a) {
    var _b;
    var { field: { input, meta }, label, inlineLabel, placeholder, helpText, suffix, errorView, onChange, preventedInputChangeValue = false } = _a, otherProps = __rest(_a, ["field", "label", "inlineLabel", "placeholder", "helpText", "suffix", "errorView", "onChange", "preventedInputChangeValue"]);
    const touched = (_b = meta === null || meta === void 0 ? void 0 : meta.touched) !== null && _b !== void 0 ? _b : false;
    const notSubmit = !(meta === null || meta === void 0 ? void 0 : meta.submitting) && !(meta === null || meta === void 0 ? void 0 : meta.dirtySinceLastSubmit);
    const errorMessage = touched
        ? (meta && (meta.error || (notSubmit && meta.submitError))) || ''
        : '';
    const fixedPlaceholder = !placeholder ? ' ' : placeholder; // If there is no placeholder, then defaulted 'Password' from UIKit
    return (react_1.default.createElement(layout_1.FieldLayout, { label: label, inlineLabel: inlineLabel, disabled: otherProps.disabled, helpText: helpText, suffix: suffix, widthSize: otherProps.size === components_1.CONTROL_SIZE.full ? components_1.CONTROL_SIZE.full : undefined, error: errorMessage, errorView: errorView },
        react_1.default.createElement(components_1.PasswordInput, Object.assign({}, otherProps, { value: input.value, placeholder: fixedPlaceholder, error: !!errorMessage, onBlur: (e) => {
                if (!preventedInputChangeValue) {
                    input.onBlur(e);
                }
            }, onFocus: (e) => {
                if (!preventedInputChangeValue) {
                    input.onFocus(e);
                }
            }, onChange: (value) => {
                if (!preventedInputChangeValue) {
                    input.onChange(value);
                }
                onChange === null || onChange === void 0 ? void 0 : onChange(value);
            } }))));
}
exports.PasswordField = PasswordField;
PasswordField.displayName = 'PasswordField';
//# sourceMappingURL=PasswordField.js.map